import { types } from "../types";

const NavigationAction = {
  navigationsuccess: (path) => {    
    return { type: types.NavigationSuccess, path };
  }
};

export default NavigationAction;
